module.exports = __webpack_public_path__ + "static/turtle-creek-house09-d44678e03fc572af6988f072e8313c8e.jpg";